import type { AppStore } from "@/store/store";
import { selectIsSavingDraftChanges } from "./draft-saving-selectors";

/**
 * Waits for in-progress draft saves (hierarchy changes and user edits) to finish before leaving the page.
 *
 * @param store The application store that owns the draft saving state.
 * @returns A promise that resolves when no draft save is in progress.
 */
export function waitForDraftSavesToFinish(store: AppStore): Promise<void> {
  if (!selectIsSavingDraftChanges(store.getState())) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const unsubscribe = store.subscribe(() => {
      if (!selectIsSavingDraftChanges(store.getState())) {
        unsubscribe();
        resolve();
      }
    });
  });
}
